import React from "react";
import { TimelineLite } from "gsap/";
import HeadingContent from "./HeadingContent";
import Form from "./Form";
import DataInput from "./DataInput";
import { FloatingLableInput } from "./AnimatedInput";
import AutoComplete from "./Autocomplete";
import { register, getPendingOrder, getPayment } from "./Services";
import { cityOption, genderOptions, razorPayScript } from "../Constants";
import ThankYou from "./ThankYou";
import TermsAndConditions from "./TermsAndConditions";
import CSSPlugin from "gsap";
import { getQueryParameters } from "./Utilities";

const C = CSSPlugin;

export default class PlanForms extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedPlanIndex: 0,
      isAgree: true,
    };
    this.TermsRef = null;
    this.planFormRef = null;
    this.termsAnimation = new TimelineLite({
      paused: true,
      onComplete: () => this.setShowTerms,
      onReverseComplete: () => {},
    });
  }
  componentDidMount() {
    const rozarPayScript = document.createElement("script");
    rozarPayScript.src = razorPayScript;
    document.body.appendChild(rozarPayScript);
    this.termsAnimation
      .to(this.planFormRef, 0.3, {
        opacity: 0,
        x: 400,
        autoAlpha: 0,
        height: 0,
        width: 0,
        display: "none",
      })
      .to(this.TermsRef, 0.1, {
        opacity: 1,
        autoAlpha: 1,
        height: "80%",
        width: "80%",
        display: "flex",
      });
  }
  onSubmit = async (data) => {
    let { loading } = this.state || {};
    if (loading) {
      return;
    }
    this.setState({ loading: true });
    let registerResult = await register({ params: data });
    let { code, message } = registerResult || {};
    if (code === 200) {
      let { plans } = this.props;
      let { selectedPlanIndex } = this.state;
      let currentPlan = plans[selectedPlanIndex];
      let product_type = currentPlan.product_type;

      let { plan_master_id, service_tax, actual_amount, selling_amount } =
        currentPlan;
      let { app_key, user_id } = registerResult;
      let transaction_id = user_id + "-" + new Date().getTime();
      const { referral_source, referral_channel } = getQueryParameters();
      let params = {
        user_id,
        plan_master_id,
        transaction_id,
        fit_prime: "0",
        product_type,
        referral_channel: referral_channel || "SBI-YONO",
        workout_price: selling_amount,
        total_order_price: actual_amount,
        service_tax,
        referral_source: referral_source || "SBI-YONO",
        payment_mode: "razorpay",
        after_discount_price: selling_amount,
        redeemed_points: 0,
        membership_plan_id: "",
        corporate_id: 90,
        coupon_code: "",
        coupon_type: "",
        coupon_discount: 0.0,
        coupon_id: "",
      };
      let getPendingData = await getPendingOrder({ params, user_id, app_key });
      let { code, razorpay_id } = getPendingData || {};
      if (code === 200) {
        getPayment({
          user_id,
          transaction_id,
          product_type,
          razorpay_id,
          after_discount_price: selling_amount,
          plan_master_id,
          user_details: { ...data, app_key, user_id },
          onCompletePayment: this.onCompletePayment,
        });
        this.setState({ loading: false });
      } else {
        this.setState({ loading: false });
      }
    } else if (code === 412) {
      this.setState({
        serverErrorMessage: message || "Something went wrong!",
      });
    }
  };
  onCardClick = (index) => {
    this.setState({ selectedPlanIndex: index });
  };

  showTermsAndConditions = () => {
    this.termsAnimation.play();
    this.setState({ showData: true });
  };
  hideTermsAndConditions = () => {
    this.termsAnimation.reverse();
  };
  render() {
    let {
      getRef,
      plans,
      onChangePlan,
      basicPlanIndex,
      onInputBlur,
      onInputFocus,
      closeModal,
    } = this.props;
    let {
      selectedPlanIndex,
      isAgree,
      showData,
      serverErrorMessage = "",
    } = this.state;
    return (
      <>
        <TermsAndConditions
          showData={showData}
          getRef={(_) => (this.TermsRef = _)}
          onClose={this.hideTermsAndConditions}
        />
        <ThankYou />
        <div
          style={{
            paddingLeft: 50,
            paddingRight: 50,
          }}
          id={"planForm"}
          ref={(_) => {
            this.planFormRef = _;
            // getRef(this.planFormRef)
          }}
          className="flex flex-1 pt45 relative justifyCenter"
        >
          <span
            onClick={closeModal}
            style={{ right: 20, top: 15 }}
            className={"absolute icon-cross"}
          ></span>

          <HeadingContent
            hideGradient={true}
            heading={
              <div>
                <span> CHOOSE YOUR PLAN? </span>
                <div className="headingGradient"></div>
                <div className="flex mt_12 mb_12">
                  <div
                    className={`planSelector ${
                      basicPlanIndex === 0 ? "selectedPlanSelector" : ""
                    }`}
                    onClick={() => onChangePlan(0)}
                  >
                    FP PRO
                  </div>
                  <div
                    className={`planSelector ml_12 ${
                      basicPlanIndex === 1 ? "selectedPlanSelector" : ""
                    }`}
                    onClick={() => onChangePlan(1)}
                  >
                    FITPASS
                  </div>
                </div>
              </div>
            }
          >
            {plans &&
              plans.map((plan, index) => {
                return (
                  <Card
                    plan={plan}
                    index={index}
                    selectedPlanIndex={selectedPlanIndex}
                    onCardClick={() => this.onCardClick(index)}
                    key={plan.duration + index}
                  />
                );
              })}
            <div className="totalPriceContainer">
              <div className="flex spaceBetween alignCenter">
                <span className={"f16 medium c1"}>Payable Amount</span>
                <span className="f24 bold c4">
                  {" "}
                  ₹{plans && plans[selectedPlanIndex].selling_amount}{" "}
                </span>
              </div>
            </div>
            <div
              className="totalPriceContainer pb_16"
              style={{ "padding-top": "0px" }}
            >
              <div className="flex spaceBetween alignCenter">
                <span className="f14 bold c4">
                  All prices include taxes & applicable charges.
                </span>
              </div>
            </div>
          </HeadingContent>
          <HeadingContent
            bodyStyle={{ overflow: "visible" }}
            className="ml40"
            heading={<span>PLEASE ENTER YOUR DETAILS </span>}
          >
            <div className="planFormContainer">
              <Form
                onSubmit={this.onSubmit}
                mandatoryFields={{
                  first_name: "Full Name",
                  mobile_no: "Mobile Number",
                  email_address: "Email",
                  gender: "Gender",
                  preferred_location: "City",
                }}
              >
                {(props) => {
                  props = {
                    ...props,
                    onFocus: onInputFocus,
                    onBlur: onInputBlur,
                  };
                  return (
                    <div className={"flex-1"}>
                      <div className="flex">
                        <DataInput
                          {...props}
                          className="flex-1"
                          field={"first_name"}
                        >
                          <FloatingLableInput
                            key={"fullName"}
                            field={"first_name"}
                            autoFocus
                            label={"Full Name"}
                          />
                        </DataInput>
                        <DataInput
                          {...props}
                          className="ml20 flex-1"
                          field={"mobile_no"}
                          validate={{
                            type: "mobile",
                            message: "Please enter valid Mobile No.",
                          }}
                        >
                          <FloatingLableInput
                            key={"mobileNumber"}
                            field={"mobile_no"}
                            autoFocus
                            label={"Mobile Number"}
                          />
                        </DataInput>
                      </div>

                      <div className="flex">
                        <DataInput
                          {...props}
                          className="flex-1"
                          field={"email_address"}
                          validate={{
                            type: "email",
                            message: "Please enter valid Email Id",
                          }}
                        >
                          <FloatingLableInput
                            key={"email_address"}
                            field={"email_address"}
                            autoFocus
                            label={"Email"}
                          />
                        </DataInput>
                        <DataInput
                          {...props}
                          className="ml20 mt_15 flex-1"
                          field={"gender"}
                        >
                          <AutoComplete
                            key={"gender"}
                            placeholder="Gender"
                            options={genderOptions}
                            field={"gender"}
                            autoFocus
                            label={"Gender"}
                          />
                        </DataInput>
                      </div>

                      <div className="flex">
                        <DataInput
                          {...props}
                          className="flex-1 mt_15"
                          field={"preferred_location"}
                        >
                          <AutoComplete
                            key={"preferred_location"}
                            placeholder="City"
                            options={cityOption}
                            field={"preferred_location"}
                            autoFocus
                            label={"Select City"}
                          />
                        </DataInput>

                        <div
                          onClick={isAgree && props.onSubmit}
                          style={{ opacity: isAgree ? 1 : 0.8 }}
                          className="submitButton ml20 flex alignCenter justifyCenter"
                        >
                          Submit
                        </div>
                      </div>
                      {serverErrorMessage && (
                        <div className={"errorStyle"}>{serverErrorMessage}</div>
                      )}
                      <div className="mt12 flex alignCenter c1">
                        <div
                          onClick={() => {
                            this.setState({ isAgree: !isAgree });
                          }}
                          style={{
                            background: "#38227a",
                            marginRight: 20,
                            height: 24,
                            width: 24,
                            borderRadius: 3,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          {isAgree && (
                            <img
                              style={{ height: "80%", width: "80%" }}
                              src="/images/ic_check.svg"
                            />
                          )}
                        </div>{" "}
                        I agree to the{" "}
                        <div
                          onClick={this.showTermsAndConditions}
                          style={{
                            textDecoration: "underline",
                            cursor: "pointer",
                          }}
                          className="ml5"
                        >
                          {" "}
                          terms and conditions.{" "}
                        </div>
                      </div>
                    </div>
                  );
                }}
              </Form>
            </div>
          </HeadingContent>
        </div>
      </>
    );
  }
}

class Card extends React.Component {
  render() {
    let { plan, onCardClick, index, selectedPlanIndex } = this.props;
    let {
      membership_price,
      actual_amount,
      selling_amount,
      subscription_amount,
      membership_validity,
      product_name,
    } = plan || {};
    return (
      <div
        onClick={onCardClick}
        style={{
          background: selectedPlanIndex === index ? "#81ff8f" : "white",
        }}
        className="flex planCard spaceBetween"
      >
        <div>
          <div className="f20 c1 medium">{product_name}</div>
          <div className="cardGradient"></div>
          <div className="f12 c1 medium">{membership_validity}</div>
        </div>
        <div className={"flex alignCenter ml_20"}>
          <strike className="f16 c5"> ₹{actual_amount}</strike>
          <div className="f24 ml_10 c1 bold">₹{selling_amount}</div>
        </div>
      </div>
    );
  }
}
